export const getLocaleParkGuides = (locale?: string) => {
  if (locale === 'en-ca' || locale === 'fr-ca') {
    return CANADA_PARK_GUIDES;
  }

  return USA_PARK_GUIDES;
};

const USA_PARK_GUIDES = [
  {
    name: 'Great Smoky Mountains National Park',
    count: '349',
    image:
      'https://d1o5877uy6tsnd.cloudfront.net/marketplace-search-production/images/page/homepage/location_smoky_mountains-c54de15e9d814277c7b26e39ff7cc7d3.jpg',
    link: '/guide/great-smoky-mountains-national-park',
  },
  {
    name: 'Rocky Mountain National Park',
    count: '873',
    image:
      'https://d1o5877uy6tsnd.cloudfront.net/marketplace-search-production/images/page/homepage/location_rocky_mountains@2x-4045758a779de340550ad16a513edb28.jpg',
    link: '/guide/rocky-mountain-national-park',
  },
  {
    name: 'Joshua Tree National Park',
    count: '1334',
    image:
      'https://d1o5877uy6tsnd.cloudfront.net/marketplace-search-production/images/page/homepage/location_joshua_tree@2x-1b4f4dd97748aa5d8e0dc1cfb07ba461.jpg',
    link: '/guide/joshua-tree-national-park',
  },
  {
    name: 'Olympic National Park',
    count: '1009',
    image:
      'https://d1o5877uy6tsnd.cloudfront.net/marketplace-search-production/images/page/homepage/location_olympic@2x-0c9eb9968126aa85898a14d2544d5c43.jpg',
    link: '/guide/olympic-national-park',
  },
  {
    name: 'Zion National Park',
    count: '103',
    image:
      'https://d1o5877uy6tsnd.cloudfront.net/marketplace-search-production/images/page/homepage/location_zion@2x-bb60341d359562c74a0299646181e45d.jpg',
    link: '/guide/zion-national-park',
  },
];

const CANADA_PARK_GUIDES = [
  {
    name: 'Banff National Park',
    count: '273',
    image:
      'https://d1o5877uy6tsnd.cloudfront.net/marketplace-search-production/images/page/homepage/canada/location_banff@2x-754e5bc85fc134e40700fcb3c315bd2b.jpg',
    link: '/guide/banff-national-park-ab',
  },
  {
    name: 'Elk Island National Park',
    count: '157',
    image:
      'https://d1o5877uy6tsnd.cloudfront.net/marketplace-search-production/images/page/homepage/canada/location_elk_island@2x-239f5ef10e77cdfcfe5c246d7b8cb21b.jpg',
    link: '/guide/elk-island-national-park',
  },
  {
    name: 'Jasper National Park',
    count: '102',
    image:
      'https://d1o5877uy6tsnd.cloudfront.net/marketplace-search-production/images/page/homepage/canada/location_jasper@2x-f50b09ea442e7136c6f52757230485cf.jpg',
    link: '/guide/jasper-national-park',
  },
  {
    name: 'Tombstone Territorial Park',
    count: '24',
    image:
      'https://d1o5877uy6tsnd.cloudfront.net/marketplace-search-production/images/page/homepage/canada/location_kluane@2x-2f849b80e74311bbce09f91b78171e23.jpg',
    link: '/guide/tombstone-territorial-park',
  },
  {
    name: 'Riding Mountain National Park',
    count: '93',
    image:
      'https://d1o5877uy6tsnd.cloudfront.net/marketplace-search-production/images/page/homepage/canada/location_riding_mountain@2x-e81ecd23002eeb82f5dfd9c3d51051e1.jpg',
    link: '/guide/riding-mountain-national-park',
  },
];

const DURANGO_PARK_GUIDES = [
  {
    name: 'Mesa Verde National Park',
    image:
      'https://dsqeev865ph38.cloudfront.net/media/original_images/winter-mesa-verde-national-park.jpg',
    link: '/guide/mesa-verde-national-park',
  },
  {
    name: 'Aztec Ruins National Monument',
    image:
      'https://dsqeev865ph38.cloudfront.net/media/original_images/winter-aztec-ruins-national-monument.jpg',
    link: '/guide/aztec-ruins-national-monument',
  },
  {
    name: 'Hovenweep National Monument',
    image:
      'https://dsqeev865ph38.cloudfront.net/media/original_images/winter-hovenweep-national-monument.jpg',
    link: '/guide/hovenweep-national-monument',
  },
];

const BASS_LAKE_PARK_GUIDES = [
  {
    name: 'Yosemite National Park',
    image:
      'https://dsqeev865ph38.cloudfront.net/media/original_images/winter-yosemite-national-park.jpg',
    link: '/guide/yosemite-national-park',
  },
  {
    name: 'Death Valley National Park',
    image:
      'https://dsqeev865ph38.cloudfront.net/media/original_images/winter-death-valley-national-park.jpg',
    link: '/guide/death-valley-national-park',
  },
  {
    name: 'Sequoia National Park',
    image:
      'https://dsqeev865ph38.cloudfront.net/media/original_images/winter-sequoia-national-park.jpg',
    link: '/guide/sequoia-national-park',
  },
];

const TEXAS_HILL_COUNTRY_PARK_GUIDES = [
  {
    name: 'Garner State Park',
    image:
      'https://dsqeev865ph38.cloudfront.net/media/original_images/off-garner-state-park-tx.jpg',
    link: '/guide/garner-state-park-tx',
  },
  {
    name: 'Canyon Lake',
    image:
      'https://d1o5877uy6tsnd.cloudfront.net/marketplace-search-production/img/en-us/homepage/hero-25846d08b7207d696c43e6f9e6a7e3ab.jpg',
    link: '/guide/canyon-lake',
  },
  {
    name: 'Waco Mammoth National Monument',
    image:
      'https://dsqeev865ph38.cloudfront.net/media/original_images/winter-waco-mammoth-national-monument.jpg',
    link: '/guide/waco-mammoth-national-monument',
  },
];

// Hardcode the guides for our campgrounds, replace this with real data when available
export const getCampgroundNearbyParkGuides = (name?: string) => {
  if (name === 'Outdoorsy Bayfield') return DURANGO_PARK_GUIDES;
  if (name === 'Outdoorsy Yosemite') return BASS_LAKE_PARK_GUIDES;
  if (name === 'Outdoorsy Hill Country') return TEXAS_HILL_COUNTRY_PARK_GUIDES;

  return USA_PARK_GUIDES;
};
